import { render, staticRenderFns } from "./retrieval.vue?vue&type=template&id=52f97bf0&scoped=true"
import script from "./retrieval.vue?vue&type=script&lang=js"
export * from "./retrieval.vue?vue&type=script&lang=js"
import style0 from "./retrieval.vue?vue&type=style&index=0&id=52f97bf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f97bf0",
  null
  
)

export default component.exports